import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of';
import * as auth0 from 'auth0-js';
import { environment } from 'environments/environment';

@Injectable()
export class Auth0Service {

  webAuth: any;
  constructor(private router: Router, private http: HttpClient) { }

  init() {
    this.webAuth = new auth0.WebAuth({
      clientID: environment.Auth0_clientId,
      domain: environment.Auth0_domain,
      scope: 'token profile openid',
      responseMode: 'fragment',
      responseType: 'token',
      redirectUri: location.origin,
      audience: 'http://auth0/4ptEngine'
    });
  }

  checkPopup() {
    if (location.href.indexOf('access_token') > -1) {
      this.webAuth.popup.callback(null);
    }
  }

  /** Auth0 Signup */
  signup(user): Observable<any> {
    const that = this;
    return new Observable(observer => {
      this.webAuth.signup({
        connection: 'Username-Password-Authentication',
        email: user.username,
        password: user.password
      }, function(err, authResult) {
        if (err && err.description) {
          observer.error(err.description);
        } else if (authResult) {
          observer.next(authResult);
        }

        observer.complete();
      });
    });
  }

  authorize(email?, password?): Observable<any> {
    const options = {
      'grant_type': 'password',
      'username': email,
      'password': password,
      'scope': 'openid',
      'client_id': environment.Auth0_clientId,
      'client_secret': environment.Auth0_clientSecret,
      'audience' : 'http://auth0/4ptEngine'
    };
    return this.http.post(environment.Auth0_API + '/oauth/token', options);
  }

  authorize_social(connection): Observable<any> {
    return new Observable(observer => {
      return this.webAuth.popup.authorize({connection: connection}, (err, authResult) => {
        if (err && err.description) {
          observer.error(err.description);
        }

        if (authResult) {
          observer.next(authResult);
        }
        observer.complete();
      });
    });
  }

  checkSession(): Observable<any> {
    return new Observable(observer => {
      return this.webAuth.checkSession({}, (err, authResult) => {
        if (err && err.description) {
          observer.error(err.description);
        }
        if (authResult) {
          observer.next(authResult);
        }
        observer.complete();
      });
    });
  }

  userInfo(token): Observable<any> {
    return new Observable(observer => {
      return this.webAuth.client.userInfo(token, (err, user) => {
        if (err && err.description) {
          observer.error(err.description);
        }

        if (user) {
          observer.next(user);
        }
        observer.complete();
      });
    });
  }

  changePassword(email): Observable<any> {
    return new Observable(observer => {
      return this.webAuth.changePassword({
        connection: 'db-conn',
        email:   email
      }, (err, resp) => {
        if (err && err.description) {
          observer.error(err.description);
        }
        if (resp) {
          observer.next(resp);
        }
        observer.complete();
      });
    });
  }

  logout() {
    this.webAuth.logout({
      returnTo: location.origin
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/common/services/auth0/auth0.service.ts